import { j as m } from "./jsx-runtime-3tyXYecC.mjs";
import { forwardRef as i } from "react";
import { m as p } from "./tss-DN0acMKN.mjs";
import { M as c, d as f } from "./constants-CnFYFetN.mjs";
import { t as l, u } from "./transformSpacingProps-m0OnDuSS.mjs";
import { B as d } from "./Box-B5hjovXR.mjs";
import { f as x } from "./format-base-props-8NDUNDcL.mjs";
const B = p()(({ mode: o, spacing: t }, r) => ({
  root: {
    outline: o === c.Dye ? `1px solid ${f.main}` : void 0,
    ...l(r, t)
  }
}));
function y(o, t) {
  const { children: r, objectFit: s = "fill", ...a } = o, { classes: e } = B(
    u({
      objectFit: s,
      ...a
    })
  ), n = [a["data-fabric-component"], "LayoutBox"].filter(Boolean).join(" ");
  return (
    // casting for performance
    /* @__PURE__ */ m.jsx(
      d,
      {
        className: e.root,
        "data-fabric-component": n,
        ref: t,
        ...x(a),
        children: r
      }
    )
  );
}
const F = i(y);
export {
  F as L
};
//# sourceMappingURL=layout-box-DFBM-kSI.mjs.map
